import { useTranslation } from 'react-i18next'

import { EMPTY_LIST } from '../../../../constants/common'
import Button, { BUTTON_HEIGHT_24 } from '../../../Button'
import { Tag, TAG_APPEARANCE, TAG_HEIGHT } from '../../../Tag'
import {
  QA_NAME_CLEAR_ALL,
  USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS,
} from '../UserEditAddressFormModal.constants'

import {
  filterFlatsById,
  getFlatTagText,
} from './UserEditAddressFormModalFlatTagList.utils'

import * as styles from './UserEditAddressFormModalFlatTagList.module.css'

function UserEditAddressFormModalFlatTagList({
  disabled,
  fieldName = USER_EDIT_ADDRESS_FORM_MODAL_FIELD_NAME_ADDED_FLATS,
  items,
  onSetAddress,
  onSetFieldValue,
}) {
  const { t } = useTranslation()

  function handleClear() {
    if (disabled) {
      return
    }

    onSetFieldValue(fieldName, EMPTY_LIST)
  }

  function getHandleRemoveFlat(id) {
    return () => {
      if (disabled) {
        return
      }

      const filteredFlats = filterFlatsById(items, id)

      onSetFieldValue(fieldName, filteredFlats)
      onSetAddress(filteredFlats)
    }
  }

  return (
    <div className={styles.UserEditAddressFormModalFlatTagList}>
      <Button.Contained
        isLight
        height={BUTTON_HEIGHT_24}
        qaName={QA_NAME_CLEAR_ALL}
        text={t('User.ClearAllBtnKey')}
        onClick={handleClear}
      />
      {items.map(flat => (
        <Tag
          appearance={TAG_APPEARANCE.filled}
          className={styles.tag}
          height={TAG_HEIGHT.height24}
          isDisabled={disabled}
          key={`${flat.building.id}-${flat.value}`}
          qaName={flat.value}
          text={getFlatTagText(flat, t)}
          onRemove={getHandleRemoveFlat(flat.value)}
        />
      ))}
    </div>
  )
}

export default UserEditAddressFormModalFlatTagList
